
import React from "react";
import moment from "moment";
import numberFormatter from "utils/numberFormatter";

import { LeftAlignedGrid, RightAlignedGrid, DateText } from "./sharedStyles";

const twoDecimalPlaces = 2;
const threeDecimalPlaces = 3;

const SpreadMaintenanceResult = ({ result, shouldUsePV }) => (
  <>
    <LeftAlignedGrid item xs={6}>Next Payment Date</LeftAlignedGrid>
    <RightAlignedGrid item xs={6}><DateText>{moment(result.calculationDate).format("MM/DD/YYYY")}</DateText></RightAlignedGrid>
    {shouldUsePV && <LeftAlignedGrid item xs={6}>Discount Rate</LeftAlignedGrid>}
    {shouldUsePV && <RightAlignedGrid item xs={6}>{numberFormatter.formatRate(result.discountRate, threeDecimalPlaces, "-")}</RightAlignedGrid>}
    {shouldUsePV && <LeftAlignedGrid item xs={6}>Discount Rate Lookback</LeftAlignedGrid>}
    {shouldUsePV && <RightAlignedGrid item xs={6}>{result.discountRateLookbackDays}</RightAlignedGrid>}
    <LeftAlignedGrid item xs={6}>Minimum Penalty</LeftAlignedGrid>
    <RightAlignedGrid item xs={6}>{numberFormatter.formatMoney(result.minimumPrepaymentPenalty, twoDecimalPlaces, "-")}</RightAlignedGrid>
  </>);

export default SpreadMaintenanceResult;
